import { useHistory } from 'react-router-dom';
import { LogoMunduSVG } from 'src/assets/svg';
import { Button } from 'src/components/Buttons/Button';
import { useHomePath } from 'src/view/hooks/useHomePath';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import { useTranslation } from 'react-i18next';

export const NotFound = () => {
    const signedInUser = useSignedInUser();
    const isAuthenticated = Boolean(signedInUser);
    const { push } = useHistory();
    const home = useHomePath();
    const { t } = useTranslation();
    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-lightPeach z-100 flex justify-center items-center text-woodyBrown">
            <LogoMunduSVG className=" fill-current absolute top-0 left-0 w-44 mx-4 my-7 " />
            <div className="sm:p-24 sm:shadow-lg rounded-xl flex flex-col justify-center items-center gap-5">
                <h1 className="text-lg md:text-2xl whitespace-nowrap">
                    {t('notFound.title')}
                </h1>
                {isAuthenticated ? (
                    <Button
                        title={t('notFound.goHome')}
                        onClick={() => push(home)}
                    />
                ) : (
                    <Button
                        title={t('notFound.goToLanding')}
                        onClick={() => push('/')}
                    />
                )}
            </div>
        </div>
    );
};
